import LabelFilters from './LabelFilters';

export default LabelFilters;
